module.exports = __webpack_public_path__ + "img/CRUSTACE.3450e93d.png";